/**
 * Catálogo base de cuentas estándar PCGE (Plan Contable General Empresarial) de Perú.
 * Provee las cuentas mínimas necesarias para los módulos de ventas, compras, IGV, tesorería y destinos.
 */
export const BASE_PCGE = [
  { codigo: "101101", nombre: "CAJA M/N", clase: "1", naturaleza: "ACTIVO" },
  { codigo: "104101", nombre: "CUENTAS CORRIENTES OPERATIVAS", clase: "1", naturaleza: "ACTIVO" },
  { codigo: "12121", nombre: "FACTURAS, BOLETAS Y OTROS COMPROBANTES POR COBRAR - EMITIDAS EN CARTERA", clase: "1", naturaleza: "ACTIVO" },
  { codigo: "142101", nombre: "ACCIONISTAS O SOCIOS - RETIRO DE FONDOS", clase: "1", naturaleza: "ACTIVO" },
  { codigo: "331101", nombre: "ACTIVOS FIJOS", clase: "3", naturaleza: "ACTIVO" },
  { codigo: "401111", nombre: "IGV - CUENTA PROPIA", clase: "4", naturaleza: "PASIVO" },
  { codigo: "421201", nombre: "PROVEEDORES NACIONALES", clase: "4", naturaleza: "PASIVO" },
  { codigo: "601101", nombre: "COSTO DIRECTO", clase: "6", naturaleza: "GASTO" },
  { codigo: "631101", nombre: "GASTO ADMINISTRATIVO", clase: "6", naturaleza: "GASTO" },
  { codigo: "641101", nombre: "GASTO DE VENTAS", clase: "6", naturaleza: "GASTO" },
  { codigo: "676101", nombre: "PÉRDIDA POR DIFERENCIA DE CAMBIO", clase: "6", naturaleza: "GASTO" },
  { codigo: "701101", nombre: "VENTAS DE SERVICIOS", clase: "7", naturaleza: "INGRESO" },
  { codigo: "776101", nombre: "GANANCIA POR DIFERENCIA DE CAMBIO", clase: "7", naturaleza: "INGRESO" },
  { codigo: "791101", nombre: "CARGAS IMPUTABLES A CUENTAS DE COSTOS Y GASTOS", clase: "7", naturaleza: "DESTINO" },
  { codigo: "941101", nombre: "DESTINO COSTO DIRECTO", clase: "9", naturaleza: "DESTINO" },
  { codigo: "951101", nombre: "DESTINO GASTO ADMINISTRATIVO", clase: "9", naturaleza: "DESTINO" },
  { codigo: "951201", nombre: "DESTINO GASTO VENTAS", clase: "9", naturaleza: "DESTINO" },
];
